import { api } from '@/helpers/api'
import { useValidation } from '@/composables/utils/useValidation'

import useNotification from '@/composables/useNotification.js'

const URLS = {
    xhr: {
        fetch: {
            user: '/api/profile/v1/settings/user'
        },
        mutate: {
            register: '/register',
            login: '/api/login'
        }
    }
}

export const useDirectBookingAuth = (userData, artistPages, load) => {
    const { isValid } = useValidation()
    const { notification } = useNotification()

    async function register(v) {
        if (isValid(v)) {
            try {
                load.value = true
                const data = await api({
                    method: 'post',
                    url: URLS.xhr.mutate.register,
                    data: {
                        ...userData.value.register,
                        email: userData.value.welcome.email,
                        password_confirmation: userData.value.register.password
                    }
                })
                userData.value.id = data.id

                return true
            } catch {
                return false
            } finally {
                load.value = false
            }
        } else {
            notification('error', 'Register failed.')
            return false
        }
    }

    async function login(v) {
        if (isValid(v)) {
            try {
                load.value = true
                const data = await api({
                    method: 'post',
                    url: URLS.xhr.mutate.login,
                    data: {
                        ...userData.value.login,
                        email: userData.value.welcome.email
                    }
                })

                userData.value.id = data.user.id

                const user = await _fetchUserInfo()

                artistPages.value = user.artistPages

                return true
            } catch {
                return false
            } finally {
                load.value = false
            }
        } else {
            notification('error', 'Login failed.')
            return false
        }
    }

    async function _fetchUserInfo() {
        try {
            load.value = true
            const data = await api({
                method: 'get',
                url: URLS.xhr.fetch.user
            })

            return data.data[0]
        } finally {
            load.value = false
        }
    }
    return {
        register,
        login
    }
}
